module.exports = __webpack_public_path__ + "img/register-v2.0a9e487c.svg";